import ErrorLayout from '@/layouts/ErrorLayout'
const ErrorPage = () => (
  <div data-testid='error-page'>
    <ErrorLayout />
  </div>
)

export default ErrorPage
